import { render } from "./OrderItemsEdit.vue?vue&type=template&id=1e5a3746"
import script from "./OrderItemsEdit.vue?vue&type=script&lang=js"
export * from "./OrderItemsEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__